import * as homeActions from '../home/redux/apiCall';

import { KuposErrorSuccessModal, KuposInput, KuposSelectBox, KuposTextArea } from '../common';
import React, { useState } from 'react';

import { AppData } from '../../services';
import CommonService from '../../services/commonService';
import HeroSection from './HeroSection/HeroSection';
import Select from 'react-select';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { initial } from 'lodash';
import { withTranslation } from 'react-i18next';

const intialState = {
  name: '',
  document_type: '7',
  phone: '',
  email: '',
  document_number: '',
  passengers: '',
  passengerNumber: '',
  origin: '',
  destination: '',
  description: '',
  loader: false,
};

function SpecialServices(props) {
  // const [documentTypeSelected, setDocumentTypeSelected] = useState('RUT');

  const [state, setState] = useState(intialState);

  const { t } = props;
  function createMarkup(body) {
    return {
      __html: t('SPECIAL_SERVICES.DESCRIPTION'),
    };
  }

  const onChange = (val, type) => {
    // console.log('onChange', val, type);
    if (type === 'phone') {
      const number = CommonService.phoneNumberFormat(val, 9);
      setState({ ...state, [type]: number, [type + 'Error']: null });
    } else if (type === 'passengerNumber') {
      setState({ ...state, [type]: val > 0 ? val : 1, [type + 'Error']: null });
    } else if (type === 'description') {
      // setState({ ...state, [type]: val > 0 ? val : 1, [type + 'Error']: null });
      console.log('description', intialState.description);
      setState({ ...state, description: val, descriptionError: null });
    } else if (type === 'document_number') {
      const data = state.document_type === '7' ? CommonService.formatRut(val) : val;
      setState({ ...state, [type]: data, [type + 'Error']: null });
    } else {
      setState({ ...state, [type]: val, [type + 'Error']: null });
    }
  };

  const onBlur = (text, type) => {
    // console.log('onBlur', val, type);
    try {
      if (!text) {
        if (type === 'name') {
          setState({ ...state, nameError: 'VALIDATIONS.VALID_NAME' });
        } else if (type === 'phone') {
          setState({ ...state, phoneError: 'VALIDATIONS.VALID_MOBILE' });
        } else if (type === 'email') {
          setState({ ...state, emailError: 'VALIDATIONS.VALID_EMAIL' });
        } else if (type === 'document_number') {
          const error =
            state.document_type === '7' ? 'VALIDATIONS.VALID_RUT' : 'VALIDATIONS.VALID_PASSPORT';
          setState({ ...state, document_numberError: error });
        } else if (type === 'passengerNumber') {
          setState({ ...state, passengerNumberError: 'Require' });
        } else if (type === 'origin') {
          setState({ ...state, originError: ' VALIDATIONS.VALID_ORIGIN_CITY' });
        } else if (type === 'destination') {
          setState({ ...state, destinationError: 'VALIDATIONS.VALID_DESTINATION_CITY' });
        } else if (type === 'description') {
          setState({ ...state, descriptionError: 'VALIDATIONS.VALID_DESCRIPTION' });
        }
      } else {
        if (type === 'phone') {
          if (isNaN(text)) {
            setState({ ...state, phoneError: 'VALIDATIONS.VALID_MOBILE' });
          } else if (text.toString().length !== 9) {
            setState({ ...state, phoneError: 'VALIDATIONS.VALID_MOBILE_LENGTH_9' });
          }
        } else if (type === 'email') {
          if (!CommonService.isEMailValid(text)) {
            setState({ ...state, emailError: 'VALIDATIONS.VALID_EMAIL_VALIDATION' });
          }
        } else if (type === 'document_number') {
          if (state.document_type === '7') {
            const err = !CommonService.isRutValid(text) ? 'VALIDATIONS.VALID_RUT_VALID' : null;
            setState({ ...state, document_numberError: err });
          } else {
            // passport
            // setState({ ...state, document_numberError: 'VALIDATIONS.VALID_PASSPORT' });
          }
        }
        //  else if (type === 'passengerNumber') {
        //   setState({ ...state, passengerNumberError: 'Require' });
        // }
      }
    } catch (e) {
      console.log(e);
    }
  };

  const getDestinationOptions = () => {
    const options =
      props.home.uniqueCities && state.origin
        ? props.home.uniqueCities.filter(c => c.value !== state.origin.value)
        : [];
    return options;
  };

  const validate = () => {
    if (!state.name) {
      setState({ ...state, nameError: 'VALIDATIONS.VALID_NAME' });
      return false;
    } else if (isNaN(state.phone)) {
      setState({ ...state, phoneError: 'VALIDATIONS.VALID_MOBILE' });
      return false;
    } else if (state.phone.toString().length !== 9) {
      setState({ ...state, phoneError: 'VALIDATIONS.VALID_MOBILE_LENGTH_9' });
      return false;
    } else if (!state.email) {
      setState({ ...state, emailError: 'VALIDATIONS.VALID_EMAIL' });
      return false;
    } else if (!CommonService.isEMailValid(state.email)) {
      setState({ ...state, emailError: 'VALIDATIONS.VALID_EMAIL_VALIDATION' });
      return false;
    } else if (!state.description) {
      setState({ ...state, descriptionError: 'VALIDATIONS.VALID_DESCRIPTION' });
      return false;
    } else if (!state.document_number) {
      const error =
        state.document_type === '7' ? 'VALIDATIONS.VALID_RUT' : 'VALIDATIONS.VALID_PASSPORT';
      setState({ ...state, document_typeError: error });
      return false;
    }
    //  else if (state.document_type === '7' && CommonService.isRutValid(state.document_number)) {
    //   setState({ ...state, document_number: CommonService.isRutValid(state.document_number) });
    // }
    else if (!state.origin) {
      setState({ ...state, originError: ' VALIDATIONS.VALID_ORIGIN_CITY' });
      return false;
    } else if (!state.destination) {
      setState({ ...state, destinationError: 'VALIDATIONS.VALID_DESTINATION_CITY' });
      return false;
    }
    return true;
  };

  const onSubmit = e => {
    e.preventDefault();
    if (validate()) {
      const data = {
        origen_id: state.origin.value,
        destination_id: state.destination.value,
        origin: state.origin.label,
        destination: state.destination.label,
        no_of_passengers: state.passengerNumber,
        description: state.description,
        contact_details: {
          document_type: state.document_type,
          document_no: state.document_number,
          name: state.name,
          email: state.email,
          phone_number: state.phone,
        },
      };
      console.log(data, '-----------');
      setState({ ...state, loader: true });

      props.actions.apiCall({
        url: AppData.BASE_URL + 'api/special_trip_details',
        method: 'POST',
        data: data,
        callback: res => onResponse(res),
      });
    }
  };

  const onResponse = res => {
    if (res && res.data && res.data.status === 200) {
      // console.log('success');
      setState({
        ...state,
        showSuccessModal: true,
        modaltitle: '¡Listo!',
        modalSuccess: true,
        modalBodyText: res.data.message,
        loader: false,
        buttonText: 'OK, CONTINUAR.',
      });
    } else {
      // console.log('failure');
      setState({
        ...state,
        showSuccessModal: true,
        modaltitle: '¡Lo sentimos!',
        modalSuccess: false,
        modalBodyText:
          res && res.data && res.data.message
            ? res.data.message
            : 'Tu solicitud de viaje especial no pudo ser enviada. Por favor intenta nuevamente o comunícate con nuestros canales de atención.',
        buttonText: 'OK, VOLVER',
        loader: false,
      });
    }
    console.log(res, '-----------');
  };
  // console.log(props, state, getDestinationOptions());

  const onClose = () => {
    if (state.modalSuccess) {
      setState(intialState);
      // window.reload();
    } else {
      setState({ ...state, showSuccessModal: false, modalBodyText: '' });
    }
  };

  return (
    <React.Fragment>
      <div style={{ marginTop: '68px' }}>
        <HeroSection
          t={t}
          title="SPECIAL_SERVICES.HEADING"
          description="SPECIAL_SERVICES.HERO_DES"
          height="40vh"
          heroImage="/images/special-services/special-services-banner.jpg"
        />
      </div>
      <div className="content-container">
        <div className="pullman-section-primary-row ">
          <div className="black-text pullman-section-primary-row-main-heading margin-T30">
            {t('SPECIAL_SERVICES.TITLE')}
          </div>
          <div className="pullman-section-primary-row-underline margin-B25"></div>
        </div>
        <div className="special-service-sub-heading margin-B20">
          <p dangerouslySetInnerHTML={createMarkup()}></p>
        </div>
        <div className="special-services__form-box">
          <div className="pullman-section-primary-row">
            <div className="pullman-section-primary-row-main-heading black-text margin-T25">
              {t('SPECIAL_SERVICES.FORM_TITLE')}
            </div>
            <div className=" pullman-section-primary-row-underline margin-B30"></div>
          </div>
          {/* <form onSubmit={onSubmit}> */}
          <div className="special-service-form content-container">
            <div className="special-service-form-row ">
              <div className="special-service-input">
                <KuposInput
                  label={t('SPECIAL_SERVICES.NAME')}
                  // type="number"
                  className="kupos-border"
                  value={state.name}
                  error={state.nameError ? true : false}
                  placeholder="Maria"
                  errorMessage={state.nameError}
                  onChange={e => onChange(e, 'name')}
                  onBlur={text => onBlur(text, 'name')}
                />
              </div>

              <div className="special-service-input">
                <label className="label">{t('SPECIAL_SERVICES.DOCUMENT_TYPE')}</label>
                <div className="d-flex" style={{ marginBottom: '12px' }}>
                  <div className="special-service__form__left-form-group__checkbox d-flex align-items-center  mr-4">
                    <div
                      className="special-service__form__left-form-group__checkbox--outer-shell pointer "
                      onClick={() => onChange('7', 'document_type')}
                    >
                      {state.document_type === '7' && (
                        <div className="special-service__form__left-form-group__checkbox--selected"></div>
                      )}
                    </div>
                    <label className="checkbox-label mb-0">Chileno</label>
                  </div>

                  <div className="special-service__form__left-form-group__checkbox d-flex align-items-center  ">
                    <div
                      className="special-service__form__left-form-group__checkbox--outer-shell pointer "
                      onClick={() => onChange('3', 'document_type')}
                    >
                      {state.document_type === '3' && (
                        <div className="special-service__form__left-form-group__checkbox--selected"></div>
                      )}
                    </div>
                    <label className="checkbox-label mb-0">Otro</label>
                  </div>
                </div>
              </div>
            </div>

            <div
              className="special-service-form-row "
              style={{
                marginBottom: '17px',
              }}
            >
              <div className="special-service-input">
                <KuposInput
                  label={t('SPECIAL_SERVICES.TELEFONE')}
                  type="tel"
                  className="kupos-border"
                  value={state.phone}
                  // max={9}
                  error={state.phoneError ? true : false}
                  errorMessage={state.phoneError}
                  onChange={e => onChange(e, 'phone')}
                  onBlur={text => onBlur(text, 'phone')}
                  // placeholder="+56 9 0000 0000"
                  placeholder="9XXXXXXXX"
                />
              </div>
              <div className="special-service-input">
                <KuposInput
                  label={t('SPECIAL_SERVICES.EMAIL')}
                  // type="email"
                  placeholder="example@gmail.com"
                  className="kupos-border"
                  value={state.email}
                  error={state.emailError ? true : false}
                  errorMessage={state.emailError}
                  onChange={e => onChange(e, 'email')}
                  onBlur={text => onBlur(text, 'email')}
                />
              </div>
              <div className="special-service-input">
                <KuposInput
                  label={t('SPECIAL_SERVICES.DOCUMENT_NUMBER')}
                  type="tel"
                  className="kupos-border"
                  placeholder="XX.XXX.XXX-X"
                  value={state.document_number}
                  error={state.document_numberError ? true : false}
                  errorMessage={state.document_numberError}
                  onChange={e => onChange(e, 'document_number')}
                  onBlur={text => onBlur(text, 'document_number')}
                />
              </div>
              <div className="special-service-input">
                <KuposInput
                  label={t('SPECIAL_SERVICES.PASSENGER_NUMBER')}
                  type="number"
                  className="kupos-border"
                  value={state.passengerNumber}
                  error={state.passengerNumberError ? true : false}
                  errorMessage={state.passengerNumberError}
                  onChange={e => onChange(e, 'passengerNumber')}
                  onBlur={text => onBlur(text, 'passengerNumber')}
                  placeholder="0"
                />
              </div>
            </div>

            <div className="special-service-form-row mt-2">
              <div className="special-service-input">
                <label className="label">{t('SPECIAL_SERVICES.ORIGIN')}</label>
                <KuposSelectBox
                  reactSelect
                  selectType="origin"
                  options={props.home.uniqueCities}
                  selectedOption={state.origin}
                  onChange={e => onChange(e, 'origin')}
                  onInputChange={e => console.log('dfsdf')}
                  icon="/images/search-bar/search-bar-origin.svg"
                  hideArrow={false}
                  error={state.originError ? true : false}
                  errorMessage={t('VALIDATIONS.VALID_ORIGIN_CITY')}
                  // icon="/images/search-bar/search-bar-origin.svg"
                  placeholder={t('HOME.ORIGIN')}
                  height={40}
                  t={t}
                  iconStyle={{ marginTop: '-10px' }}
                  addCustomStyling={true}
                />
              </div>
              <div className="special-service-input">
                <label className="label">{t('SPECIAL_SERVICES.DESTINATION')}</label>
                <KuposSelectBox
                  reactSelect
                  options={getDestinationOptions()}
                  selectedOption={state.destination}
                  onChange={e => onChange(e, 'destination')}
                  // onInputChange={e => onChange(e, 'destination')}
                  icon="/images/search-bar/search-bar-destination.svg"
                  hideArrow={false}
                  error={state.destinationError ? true : false}
                  errorMessage={t('VALIDATIONS.VALID_DESTINATION_CITY')}
                  placeholder={t('HOME.DESTINATION')}
                  height={40}
                  t={t}
                  addCustomStyling={true}
                />
              </div>
            </div>
            <div className="special-service-form-row label">
              <div className="special-service-input-text-area">
                <label>{t('SPECIAL_SERVICES.OPTIONAL')}</label>
                <KuposTextArea
                  rows="10"
                  className="special-service-form-group__textarea w-100"
                  value={state.description}
                  onBlur={text => onBlur(text, 'description')}
                  onChange={e => onChange(e, 'description')}
                  error={state.descriptionError ? true : false}
                  errorMessage={t('VALIDATIONS.VALID_DESCRIPTION')}
                  placeholder="Commentario"
                />
              </div>
            </div>

            <div className="special-service-form-row right">
              <button className="button" type="submit" onClick={onSubmit} disabled={state.loader}>
                {state.loader ? (
                  <div className="loader-cricle"></div>
                ) : (
                  <React.Fragment>{t('SPECIAL_SERVICES.BUTTON')}</React.Fragment>
                )}
              </button>
            </div>
          </div>
          {/* </form> */}
        </div>
      </div>

      <KuposErrorSuccessModal
        showModal={state.showSuccessModal}
        success={state.modalSuccess}
        title={state.modaltitle}
        showButton1
        buttonText1={state.buttonText}
        onButtonClick1={onClose}
        bodyText={state.modalBodyText}
        t={t}
      />
    </React.Fragment>
  );
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    home: state.home,
    common: state.common,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...homeActions }, dispatch),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation('common')(SpecialServices));



// WEBPACK FOOTER //
// ./src/features/pages/SpecialServices.js